import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const ManageSmc = Loadable(lazy(() => import("./SmcList")));
const AddSmc = Loadable(lazy(() => import("./AddSmc")));
const EditSmc = Loadable(lazy(() => import("./EditSmc")));

const manageSmcRoutes = [
    { path: "/smc-user/list", element: <ManageSmc/> },
    { path: "/smc-user/add-smc", element: <AddSmc/> },
    { path: "/smc-user/edit-smc", element: <EditSmc/> },
];
export default manageSmcRoutes;